import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../app/hooks'
import { AddWorkoutAsync, GetInstructorAsync, GetWorkoutTypesAsync, selectInstructorList, selectWorkoutTypesList } from '../features/add_workout/workoutSlice'
import { toast } from 'react-toastify';
import { Button, Checkbox, FormControlLabel, MenuItem, TextField } from '@mui/material';
import styles from './style/addWorkout.module.css'
import CustomTextField from './CustomTextField';

const AddWorkout = () => {
  const dispatch = useAppDispatch();
  const instructors = useAppSelector(selectInstructorList);
  const workoutTypes = useAppSelector(selectWorkoutTypesList);

  const [workoutDate, setDate] = useState("")
  const [workoutTime, setTime] = useState("")
  const [Location, setLocation] = useState("")
  const [instructor, setInstructor] = useState("")
  const [MaximumParticipants, setMaximumParticipants] = useState(0)
  const [Notes, setNotes] = useState("")
  const [Terms, setTerms] = useState("");
  const [Type, setType] = useState("")
  const [FullForm, setFullForm] = useState(false)
  const [price, setPrice] = useState(0)

  useEffect(() => {
    dispatch(GetInstructorAsync()).unwrap().catch((err) => console.error("Handled error:", err));
    dispatch(GetWorkoutTypesAsync()).unwrap().catch((err) => console.error("Handled error:", err));

    // eslint-disable-next-line
  }, [])

  const handleSubmit = () => {
    const data = { 'date': workoutDate, 'time': workoutTime, "instructorId": instructor, "location": Location, "typeId": Type, "maximumParticipants": MaximumParticipants as number, "notes": Notes, "terms": Terms, "fullForm": FullForm, "isActive": true, "price":price };
    let noErrors = document.querySelector<HTMLInputElement>('form[id="addForm"]')?.checkValidity();
    if (noErrors && workoutDate !== '' && workoutTime !== '' && instructor !== "" && Location !== '' && Type !== "" && MaximumParticipants !== 0) {
      dispatch(AddWorkoutAsync(data)).unwrap()
        .then(() => {
          toast.success("האימון התווסף בהצלחה!")
          const form = document.getElementById('addForm') as HTMLFormElement;
          form.reset();
          setInstructor("");
          setType("");
          setNotes("");
          setTerms("");
        })
        .catch((err) => {
          toast.error("אירעה שגיאה")
        })
    }
    else 
      toast.error("קיימת טעות בטופס, אנא וודא את הפרטים שמולאו");
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
      <form id='addForm' method='post' onSubmit={(e) => { e.preventDefault(); }} noValidate>
        <h1>יצירת אימון</h1><br />
        <div className={styles.formGrid}>
          <TextField className={styles.div1} variant="filled" label='תאריך האימון' type='date' slotProps={{ htmlInput: { min: new Date().toISOString().slice(0, 10) }, inputLabel: { shrink: true } }} onChange={(e) => setDate(e.target.value)} required />
          <TextField className={styles.div2} variant="filled" label='שעת התחלת האימון' type='time' onChange={(e) => setTime(e.target.value)} required slotProps={{ inputLabel: { shrink: true } }} />
          <TextField className={styles.div3} variant="filled" label='מיקום האימון' type='text' onChange={(e) => setLocation(e.target.value)} required />
          <TextField className={styles.div4} variant="filled" label='מדריך האימון' select onChange={(e) => setInstructor(e.target.value)} required value={instructor ?? ''}>
            {instructors !== undefined && instructors.map((value, index) => <MenuItem key={index} value={value.id}>{value.fullName}</MenuItem>)}
          </TextField>
          <TextField className={styles.div5} variant="filled" label='סוג האימון' select onChange={(e) => setType(e.target.value)} required value={Type ?? ''}>
            {workoutTypes !== undefined && workoutTypes.map((value, index) => <MenuItem key={index} value={value.id}>{value.name}</MenuItem>)}
          </TextField>
          <TextField className={styles.div6} variant="filled" label='כמות מקסימלית של משתתפים באימון' type='number' onChange={(e) => setMaximumParticipants(+e.target.value)} required slotProps={{ htmlInput: { min: 1 } }} />
          <CustomTextField className={styles.div7} variant="filled" label='הערות' type='text' onChange={(e) => setNotes(e.target.value)} value={Notes} slotProps={{ htmlInput: { maxLength: 256 } }} counter />
          <CustomTextField className={styles.div8} variant="filled" label='תנאים' type='text' multiline rows={4} onChange={(e) => setTerms(e.target.value)} value={Terms} slotProps={{ htmlInput: { maxLength: 1001 } }} counter />
          <CustomTextField className={styles.div11} variant="filled" label='מחיר' type='number' onChange={(e) => setPrice(+e.target.value)} required slotProps={{ htmlInput: { min: 0 } }}/>
          <br />
          <FormControlLabel className={styles.div9}
            control={<Checkbox checked={!!FullForm} onChange={() => setFullForm(!FullForm)} />}
            label="טופס הרשמה מלא"
            labelPlacement="end"
          />
          <Button className={styles.div10} type='submit' onClick={() => handleSubmit()} variant="contained" size='large' color='success'>הוסף אימון</Button>
        </div>
      </form>
    </div>
  )
}

export default AddWorkout